import React, { useState, useEffect } from "react";
import { HashRouter as Link, useHistory, useLocation } from "react-router-dom";
import { HiMenuAlt2 } from "react-icons/hi";
import { IconContext } from 'react-icons';
import { ImCross } from "react-icons/im";
import { FiLogOut } from "react-icons/fi";

const Nav = (props) => {
  const [sideNavDisplay, setsideNavDispaly] = useState(false)
  const location = useLocation();
  let history = useHistory();

  const displaySideNav = () => {
    if (sideNavDisplay) {
      setsideNavDispaly(false);
    }
    else {
      setsideNavDispaly(true);
    }
  }
  const handleResize = () => {
    if (window.innerWidth >= 950) {
      setsideNavDispaly(true);
    }
    else {
      setsideNavDispaly(false);
    }
  }

  const handleNav1Onclick = (event) => {
    event.preventDefault();
    history.push(props.path1);
    setsideNavDispaly(false);
  }
  const handleNav2Onclick = (event) => {
    event.preventDefault();
    history.push(props.path2);
    setsideNavDispaly(false);
  }
  const handleNav3Onclick = (event) => {
    event.preventDefault();
    history.push(props.path3);
    setsideNavDispaly(false);
  }
  const handleNav4Onclick = (event) => {
    event.preventDefault();
    history.push(props.path4);
    setsideNavDispaly(false);
  }
  const handleNav5Onclick = (event) => {
    event.preventDefault();
    history.push(props.path5);
    setsideNavDispaly(false);
  }
  const handleNav6Onclick = (event) => {
    event.preventDefault();
    history.push(props.path6);
    setsideNavDispaly(false);
  }

  const logout = () => {
    if (props.headerText === "ADMIN") {
      localStorage.removeItem("adminToken");
      history.push("/login");
    }
    else {
      localStorage.removeItem("staffToken");
      history.push("/login");
    }

  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
  }, []);
  return (
    <div>
      <div className="header-wrapper">
        <div className="header-text-wrapper">
          <h2 className="header-h1" id="header-text">{props.headerText}</h2>
        </div>
        <IconContext.Provider
          value={{ color: '#fff', size: '23px' }}
        >
          <div className="header-icon">
            <i onClick={displaySideNav}>
              {sideNavDisplay ? <ImCross /> : <HiMenuAlt2 />}

            </i>
          </div>
        </IconContext.Provider>
      </div>
      <div className={`side-nav-wrapper ${sideNavDisplay ? "visible" : ""}`}>
        <div className="side-nav-inner-wrapper">
          <div className="logo">
            <h2 className="header-text" id="header-text">{props.headerText}</h2>
          </div>
          <div className="side-nav-container">
            <ul className="side-nav">
              <IconContext.Provider
                value={{ color: '#fff', size: '30px' }}
              >
                <li className={`side-nav-item ${location.pathname === props.path1 || location.pathname === "/addService" ? "active" : ""}`} onClick={handleNav1Onclick}>
                  <i style={{ position: "relative", top: "10px", right: "5px" }}>{props.icon1}</i>
                  <span>{props.nav1}</span>
                </li>
                <li className={`side-nav-item ${location.pathname === props.path2 ? "active" : ""}`} onClick={handleNav2Onclick}>

                  <i style={{ position: "relative", top: "10px", right: "5px" }}>{props.icon2}</i>
                  <span>{props.nav2}</span>

                </li>
              </IconContext.Provider>
              <IconContext.Provider
                value={{ color: '#fff', size: '22px' }}
              >
                <li className={`side-nav-item ${location.pathname === props.path3 ? "active" : ""}`} onClick={handleNav3Onclick}>

                  <i style={{ position: "relative", top: "5px", right: "5px" }}>{props.icon3}</i>
                  <span>{props.nav3}</span>

                </li>
                <li className={`side-nav-item ${location.pathname === props.path4 ? "active" : ""}`} onClick={handleNav4Onclick}>

                  <i style={{ position: "relative", top: "5px", right: "5px" }}>{props.icon4}</i>
                  <span>{props.nav4}</span>

                </li>
              </IconContext.Provider>


              <li className="logout-side-nav-item" onClick={logout}>
                <i style={{ position: "relative", top: "4px", right: "5px", fontSize: "20px" }}><FiLogOut /></i>
                <span>Logout</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>

  )
}
export default Nav;
